import { Button, Dialog, IconButton } from "@material-ui/core";
import image from "assets/icons/waybill.svg";
import { LinearBuffer } from "components/LinearbBuffer";
import useText from "constants/text";
import { JobReacap } from "domains/Job/components/JobReacp";
import { NewJobContext } from "domains/Job/context";
import { Parcel } from "generated/graphql";
import { useCurrentClient } from "hooks";
import { useCountryCode } from "hooks/useCurrentUser";
import { DeleteIcon } from "icons";
import React from "react";
import { useNavigate } from "react-router-dom";
import "styled-components/macro";
import Checkbox from "ui/Checkbox";
import { generateAirwayBills } from "utils";
import { useAirWayBillStyles } from "./styles";

const moment = require("moment");

export interface AirbillsProps {
  setActiveStep?: React.Dispatch<React.SetStateAction<number>>;
  parcels?: Parcel[];
}
export function Airbills({ parcels }: AirbillsProps) {
  const styles = useAirWayBillStyles();
  const { client } = useCurrentClient();
  const [checked, setChecked] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [pdfs, setPdfs] = React.useState(null);
  const navigation = useNavigate();
  const { text } = useText();
  const [openAirWayBillDialog, setOpenAirWayBillDialog] = React.useState(true);
  const countryCode = useCountryCode();
  const { job, setJob, setOrders } = React.useContext(NewJobContext);
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setChecked(event.target.checked);
  };

  React.useEffect(() => {
    if (parcels) {
      setPdfs(generateAirwayBills(parcels, job, client, countryCode));
    }
  }, [parcels, client]);

  const handleClose = () => {
    setOpenAirWayBillDialog(false);
    navigation("/");
    setJob(null);
    setOrders([]);
  };

  return (
    <>
      <JobReacap />
      <Dialog open={openAirWayBillDialog} onClose={handleClose}>
        <div className={styles.rootContent}>
          <div>
            <div className={styles.close}>
              <div className={styles.title}>{text.all.airway_bills}</div>
              <IconButton aria-label="close" onClick={handleClose}>
                <DeleteIcon />
              </IconButton>
            </div>
            {loading && (
              <div>
                <LinearBuffer />
              </div>
            )}
            <img className={styles.imgAirwaysbills} src={image} alt={`the illustrator ${image}`} />
          </div>
          <div className={styles.textInfos}>
            <Checkbox
              className={styles.checkbox}
              checked={checked}
              onChange={handleChange}
              inputProps={{ "aria-label": "primary checkbox" }}
              disableRipple
            />
            <div className={styles.helperText}>{text.all.airway_bills_helpertext}</div>
          </div>

          <div className={styles.buttons}>
            <Button
              disabled={!checked || loading}
              color="primary"
              variant="contained"
              css={`
                &.MuiButton-root {
                  width: 160px;
                  margin-left: auto;
                }
              `}
              onClick={() => {
                setLoading(true);
                pdfs.download(`${moment().format("llll")}airway-bills.pdf`);
                const url = "/";
                setJob(null);
                setOrders([]);
                navigation(url);
                setOpenAirWayBillDialog(false);
              }}
            >
              {text.all.confirm}
            </Button>
          </div>
        </div>
      </Dialog>
    </>
  );
}

export default Airbills;
